import { render, staticRenderFns } from "./KioskLanguageSelector.vue?vue&type=template&id=0c6d2378&"
import script from "./KioskLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./KioskLanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./KioskLanguageSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskLanguageSelector.vue"
export default component.exports